import { useForm, router } from '@inertiajs/vue3';

export default function useAuth() {
  const logout = () => router.visit(route('logout'), { method: 'post' });
  const signInForm = useForm<{
    email: string;
    password: string;
    remember: boolean;
  }>({
    email: '',
    password: '',
    remember: false,
  });

  return {
    signInForm,
    logout,
  };
}
